import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable()
export class ImportFileService {

  constructor(private http: HttpClient) {
  }

  public importCards(formdata) {
    return this.http
      .post(`${environment.importFileEndpoint}/import/cards`, formdata, this.getImportHeaders());
  }

  public cardImportStatus(filename) {
    return this.http
      .get(`${environment.importFileEndpoint}/import/cards?importfile=${filename}`, this.getAuthHeader());
  }

  public downloadCardImportLogFile(filename) {
    return this.http
      .get(`${environment.importFileEndpoint}/import/cards?importfile=${filename}&download=true`, {
        ...this.getAuthHeader(),
        responseType: 'text'
      });
  }

  public getImportHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Basic ' + sessionStorage.getItem('token')
      })
    };
  }

  public getAuthHeader() {
    return {
      headers: new HttpHeaders({
        'Authorization': 'Basic ' + sessionStorage.getItem('token')
      })
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/import-file.service.ts